import fixed from '@/fixed';

// Single source of truth for the app menu (sidebar + home launcher).
// Visibility rules mirror the original navbar exactly:
//   show(user)  -> role/flag gate
//   hideXs      -> was `d-none d-sm-block` (hidden on phones)
//   onlyBelowLg -> was `d-lg-none` (phones/tablets only)
const isMN = (u) => u.role === fixed.roles.Master || u.role === fixed.roles.Norway;
const notMerchant = (u) => u.role !== fixed.roles.Merchant;
const isMerchant = (u) => u.role === fixed.roles.Merchant;

const sections = [
  {
    title: 'Sales',
    tone: 'peach', // pastel accent, see .tone-* in theme.css
    items: [
      {
        to: '/invoices', label: 'Invoices', icon: 'receipt', show: isMN, hideXs: true,
      },
      {
        to: '/local-stock', label: 'Search & Order', icon: 'search', show: isMN,
      },
      {
        to: '/regos-parts', label: 'Regos', icon: 'card-list', show: isMN,
      },
      {
        to: '/virtuals', label: 'Workshop', icon: 'tools', show: isMN, hideXs: true,
      },
      {
        to: '/manual', label: 'BD Stock', icon: 'box-seam', show: isMN, hideXs: true,
      },
      {
        to: '/scanner', label: 'Camera Scan', icon: 'upc-scan', show: isMN, onlyBelowLg: true,
      },
    ],
  },
  {
    title: 'Orders',
    tone: 'sky', // pastel accent, see .tone-* in theme.css
    items: [
      {
        to: '/poland-orders', label: 'Pending', icon: 'hourglass-split', show: notMerchant, hideXs: true,
      },
      {
        to: '/processed-orders', label: 'Ordered', icon: 'cart-check', show: notMerchant, hideXs: true,
      },
      {
        to: '/mobile-scanner', label: 'Scanner', icon: 'upc', show: notMerchant,
      },
      {
        to: '/packed-orders', label: 'Packages', icon: 'box', show: notMerchant, hideXs: true,
      },
      {
        to: '/merchant-order', label: 'Order', icon: 'bag', show: isMerchant, hideXs: true,
      },
      {
        to: '/merchant-order-history', label: 'Order History', icon: 'clock-history', show: isMerchant, hideXs: true,
      },
    ],
  },
  {
    title: 'Airsuspension',
    tone: 'lavender', // pastel accent, see .tone-* in theme.css
    items: [
      {
        to: '/as/scan', label: 'Stock Management', icon: 'layers', show: isMN,
      },
      {
        to: '/as/products', label: 'Products in Stock', icon: 'grid', show: isMN,
      },
    ],
  },
  {
    title: 'Checks',
    tone: 'mint', // pastel accent, see .tone-* in theme.css
    items: [
      {
        to: '/products-on-location', label: 'Check Stock', icon: 'geo-alt', show: isMN,
      },
      {
        to: '/confirm-received', label: 'Check Box Items', icon: 'check2-square', show: isMN,
      },
    ],
  },
  {
    title: 'Reports',
    tone: 'rose', // pastel accent, see .tone-* in theme.css
    items: [
      {
        to: '/stats/history', label: 'History', icon: 'clock', show: isMN,
      },
      {
        to: '/stats/workshop-stats', label: 'Workshop', icon: 'wrench', show: isMN,
      },
      {
        to: '/stats/poland-stats', label: 'Poland', icon: 'flag', show: isMN,
      },
      {
        to: '/stats/website-stats', label: 'BDbildeler', icon: 'globe', show: isMN,
      },
      {
        to: '/stats/regos-stats', label: 'Regos', icon: 'bar-chart', show: isMN,
      },
      {
        to: '/stats/as-stats', label: 'Airsuspension', icon: 'graph-up', show: isMN,
      },
      {
        to: '/stats/invoices', label: 'Invoices', icon: 'file-earmark-text', show: isMN,
      },
      {
        to: '/stats/total-stock-value', label: 'Total Stock', icon: 'stack', show: isMN,
      },
      {
        to: '/stats/overview', label: 'Platform Insights', icon: 'lightbulb', show: (u) => isMN(u) && !!u.showHidden,
      },
      {
        to: '/order-suggestions', label: 'Order Suggestions', icon: 'stars', show: (u) => isMN(u) && !!u.admin,
      },
    ],
  },
];

export function menuFor(user) {
  if (!user) return [];
  return sections
    .map((s) => ({ ...s, items: s.items.filter((i) => i.show(user)) }))
    .filter((s) => s.items.length);
}

export function itemClass(item) {
  if (item.hideXs) return 'd-none d-sm-flex';
  if (item.onlyBelowLg) return 'd-flex d-lg-none';
  return 'd-flex';
}

// A section heading is hidden at the widths where none of its items show,
// so e.g. merchants on a phone don't get an empty "Orders" heading.
export function sectionClass(section) {
  if (section.items.every((i) => i.hideXs)) return 'd-none d-sm-block';
  if (section.items.every((i) => i.onlyBelowLg)) return 'd-lg-none';
  return '';
}
